export interface FreightPayment {
    id: number;
    name: string;
}

export const emptyFreightPayment: FreightPayment = {
    id: null,
    name: ''
};
